import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import OptimizeImagesService from 'services/OptimizeImages.service';

//styles
import styles from './PersonBox.module.scss';

export default class PersonBox extends Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    photo: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    linkedInLink: PropTypes.string,
    rolledUp: PropTypes.bool.isRequired
  };

  render() {
    const {
      name,
      status,
      photo,
      description,
      linkedInLink,
      rolledUp
    } = this.props;
    return (
      <div className={styles.Container}>
        <div className={styles.Box}>
          <div
            className={styles.Image}
            style={{
              backgroundImage: `url(${OptimizeImagesService.adjustImageSize(
                photo
              )})`
            }}
          />
          <div className={styles.ImageInfo}>
            <div className={styles.PersonName}>{name}</div>
            <div className={styles.PersonPosition}>{status}</div>
            {rolledUp &&
              linkedInLink && (
                <div
                  className={`${styles.PortfolioLinkBox} ${
                    styles.PortfolioLinkBox
                  }-pullRight`}
                >
                  <a
                    href={linkedInLink}
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                  >
                    <FontAwesomeIcon
                      icon={['fab', 'linkedin-in']}
                      className={styles.PortfolioIcon}
                    />
                  </a>
                </div>
              )}
          </div>
        </div>
        {!rolledUp && (
          <div className={styles.DescriptionBox}>
            {linkedInLink && (
              <div className={styles.PortfolioLinkBox}>
                <a
                  href={linkedInLink}
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                >
                  <FontAwesomeIcon
                    icon={['fab', 'linkedin-in']}
                    className={styles.PortfolioIcon}
                  />
                </a>
              </div>
            )}
            <div className={styles.DescriptionInfo}>
              <div dangerouslySetInnerHTML={{ __html: description }} />
              {/*<div className={styles.ExperienceLink}>
              <Collapse title='doświadczenie zawodowe'>
                <div dangerouslySetInnerHTML={{ __html: experience }} />
              </Collapse>
        </div>*/}
            </div>
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Home/Sections/Management/Components/PersonBox/PersonBox.js